// extracted by mini-css-extract-plugin
export var backdrop = "Popover-module--backdrop--d30e0";
export var backdropActive = "Popover-module--backdrop-active--1c0c5";
export var container = "Popover-module--container--ff3ba";
export var containerActive = "Popover-module--container-active--7638b";
export var content = "Popover-module--content--92c4d";
export var header = "Popover-module--header--12873";
export var summary = "Popover-module--summary--ddd75";
export var title = "Popover-module--title--1c296";